module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/sumLeftRight-20cb76c46d74b227afe8220b788aff32.png";